import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=4d63e8c6&scoped=true"
import script from "./BaseInfo.vue?vue&type=script&lang=ts"
export * from "./BaseInfo.vue?vue&type=script&lang=ts"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=4d63e8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d63e8c6",
  null
  
)

export default component.exports